import { render } from "./Spark.vue?vue&type=template&id=a1ecb312&scoped=true&ts=true"
import script from "./Spark.vue?vue&type=script&lang=ts"
export * from "./Spark.vue?vue&type=script&lang=ts"

import "./Spark.vue?vue&type=style&index=0&id=a1ecb312&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ecb312"]])

export default __exports__